import React from 'react';
import createClass from 'create-react-class';
import ReservationConstants from '../../../constants/ReservationConstants';
import { withTranslation } from 'react-i18next';

const BookingStatus = createClass({
	displayName: 'BookingStatus',

	render: function () {
		const status = this.props.status;
		const { t } = this.props;

		if (status) {
			var statusText = '';
			var statusClass = 'status';
			var statusTitle = '';

			switch (status) {
				case ReservationConstants.RESERVATION_STATUS.QUOTE:
					statusText += t('Statuses.Quote');
					statusClass += ' quote';
					break;
				case ReservationConstants.RESERVATION_STATUS.PENDING:
				case ReservationConstants.RESERVATION_STATUS.PENDING_SUPPLIER:
				case ReservationConstants.RESERVATION_STATUS.PENDING_PAYMENT:
				case ReservationConstants.RESERVATION_STATUS.PENDING_SUPPORT:
					statusText += t('Statuses.Pending');
					statusClass += ' pending';
					break;
				case ReservationConstants.RESERVATION_STATUS.CANCELED:
				case ReservationConstants.RESERVATION_STATUS.CANCELLED:
					statusText += t('Statuses.Cancelled');
					statusClass += ' canceled';
					break;

				case ReservationConstants.RESERVATION_STATUS.CANCELING:
					statusText += t('Statuses.Cancelling');
					statusClass += ' canceling';
					break;

				case ReservationConstants.RESERVATION_STATUS.ABORTED:
					statusText += t('Statuses.Aborted');
					statusClass += ' canceled';
					break;
				case ReservationConstants.RESERVATION_STATUS.ERROR:
					statusText += t('Statuses.Error');
					statusClass += ' canceled';
					break;
				case ReservationConstants.RESERVATION_STATUS.APPROVED:
					statusText += t('Statuses.Confirmed');
					statusClass += ' confirmed';
					break;
				default: // Do nothing
			}

			if (statusText) {
				return (
					<div className={statusClass}>
						{status === ReservationConstants.RESERVATION_STATUS.CANCELING ? (
							<i title={t('Statuses.CancellingReservation')} className="fa fa-spin fa-spinner" />
						) : null}
						<span title={statusTitle}>{statusText}</span>
					</div>
				);
			}
		}

		return null;
	},
});

export default withTranslation()(BookingStatus);
